"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var Styled = _interopRequireWildcard(require("./styles/SideCTA.style"));
var _reactFloater = _interopRequireDefault(require("react-floater"));
var _CustomFloater = _interopRequireDefault(require("./CustomFloater/CustomFloater"));
var _core = require("@material-ui/core");
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class SideCTA extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.toggleFloater = () => {
      const previousValue = this.state.showFloater;
      this.setState({
        showFloater: !previousValue
      });
      this.props.floaterFunction();
    };
    this.closeFloater = closedBy => {
      if (this.state.showFloater) {
        this.props.secondaryButtonFunction(closedBy);
        this.setState({
          showFloater: false
        });
      }
    };
    this.closeFloaterAndProceed = () => {
      this.closeFloater('');
      this.props.primaryButtonFunction();
    };
    this.instanceOfCustomFloater = () => {
      return /*#__PURE__*/_react.default.createElement(_CustomFloater.default, {
        title: this.props.title,
        content: this.props.content,
        primaryButtonFunction: this.closeFloaterAndProceed,
        primaryButtonText: this.props.primaryButtonText,
        secondaryButtonFunction: this.closeFloater,
        secondaryButtonText: this.props.secondaryButtonText
      });
    };
    this.renderFloater = (placement, style) => {
      return /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
        onClickAway: this.closeFloater
      }, /*#__PURE__*/_react.default.createElement(_reactFloater.default, {
        open: this.state.showFloater,
        component: this.instanceOfCustomFloater,
        disableFlip: true,
        target: "#cta-side-button",
        placement: placement,
        styles: {
          arrow: {
            color: 'white'
          },
          wrapper: {
            position: 'relative',
            zIndex: 100
          },
          floaterCentered: (style === null || style === void 0 ? void 0 : style.floaterCentered) || {}
        }
      }, /*#__PURE__*/_react.default.createElement(Styled.SideButtonContainer, {
        onClick: this.toggleFloater
      }, /*#__PURE__*/_react.default.createElement(Styled.SideButton, null, /*#__PURE__*/_react.default.createElement(Styled.ModifiedSideText, {
        isModified: this.props.showModifiedRibbon,
        id: "cta-side-button"
      }, this.props.sideText)))));
    };
    this.state = {
      showFloater: this.props.showPopUP
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.controlShowExtentedCTA !== this.props.controlShowExtentedCTA) {
      this.toggleFloater();
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
      breakpoint: "sm"
    }, this.renderFloater('center', {
      floaterCentered: {
        left: '50%',
        position: 'fixed',
        top: '35%',
        width: '70%'
      }
    })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
      breakpoint: "md",
      andAbove: true
    }, this.renderFloater('right')));
  }
}
exports.default = SideCTA;